"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const ActionButton_1 = __importDefault(require("../ActionButton"));
const FractureSizes_1 = require("../../molecules/FractureSizes");
function FractureSizeButton({ active, size, onClick }) {
    return ((0, jsx_runtime_1.jsx)(Button, { active: active, onClick: onClick, "aria-label": "FractureButton", "data-e2e": 'FractureSizeButton_Button', children: (0, jsx_runtime_1.jsx)(IconContainer, { "data-e2e": 'FractureSizeButton_IconContainer', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: FractureSizes_1.sizeToIcon[size], "data-e2e": 'FractureSizeButton_ButtonIcon' }) }) }));
}
exports.default = FractureSizeButton;
const Button = (0, styled_components_1.default)(ActionButton_1.default) `
  color: ${props => props.theme.tools.fracture.buttonColor};
`;
/* @todo Container need to fix z-index bug */
const IconContainer = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 30px;
`;
